import script from "./EditEliBudgetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEliBudgetPage.vue?vue&type=script&setup=true&lang=js"

import "./EditEliBudgetPage.vue?vue&type=style&index=0&id=3218c2bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3218c2bc"]])

export default __exports__